import { memo, ReactNode, useState } from "react";
import { Flex } from "../../flex";
import { RedoHorizontalTabs } from "./redo-horizontal-tabs";

export interface TabCardTab {
  key: string;
  label: string;
  content: ReactNode;
  topRight?: ReactNode;
}

export const analyticsViewType = ["timeline", "totals"] as const;
export type AnalyticsViewType = (typeof analyticsViewType)[number];

export const totalsChartType = ["bar", "pie"] as const;
export type TotalsChartType = (typeof totalsChartType)[number];

export interface TotalsData {
  labels: string[];
  series: { label: string; data: number[]; backgroundColor?: string[] }[];
}

export interface TabCardProps {
  tabs: TabCardTab[];
  defaultTabKey?: string;
}

export const TabCard = memo(function TabCard({
  tabs,
  defaultTabKey,
}: TabCardProps) {
  const [activeTab, setActiveTab] = useState<string>(
    defaultTabKey || tabs[0]?.key || "",
  );

  const tabsConfig = tabs.map((tab) => ({ key: tab.key, label: tab.label }));

  const activeTabContent = tabs.find((tab) => tab.key === activeTab)?.content;
  const activeTabTopRight = tabs.find((tab) => tab.key === activeTab)?.topRight;

  return (
    <Flex
      bgColor="primary"
      borderColor="primary"
      borderRadius="md"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      w="full"
    >
      <Flex
        align="center"
        borderBottomWidth="1px"
        borderColor="primary"
        borderStyle="solid"
        justify="space-between"
        pr="lg"
        w="full"
      >
        <Flex align="center" pt="lg" w="full">
          <RedoHorizontalTabs
            drawBottomLine={false}
            pl="lg"
            selectedTab={activeTab}
            setSelectedTab={setActiveTab}
            tabs={tabsConfig}
          />
        </Flex>

        {activeTabTopRight && <Flex align="center">{activeTabTopRight}</Flex>}
      </Flex>
      <Flex dir="column" p="lg" style={{ minHeight: "400px" }} w="full">
        {activeTabContent}
      </Flex>
    </Flex>
  );
});
